// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"e7de5eae","453":"ecd6b1ee"}[chunkId] + ".chunk.js";
};